import React, { useState, useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import { getDoc, setDoc, doc } from "firebase/firestore";
import { db, auth } from "../../scripts/app.js";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Alert from "@mui/material/Alert";
import { MuiTelInput, matchIsValidTel } from "mui-tel-input";

import RTKTextField from "../../common/FormComponents/RTKTextField.js";
import RTKAvatarEditor from "../../common/FormComponents/RTKAvatarEditor.js";
import BreadCrumbs from "../../common/Breadcrumbs/Breadcrumbs.js";
import * as classes from "../../css/admin.module.css";

const UserProfile = () => {
  const [userID, setUserID] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");

  const { control, handleSubmit, reset, formState } = useForm({
    mode: "onBlur",
    defaultValues: {
      phone: ""
    }
  });

  useEffect(() => {
    setUserID(auth.currentUser.uid);
    getUser(auth.currentUser.uid);
  }, []);

  async function getUser(id) {
    const docRef = doc(db, "users", id);
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      console.log("Document data:", docSnap.data());
      setName(docSnap.data().name)
      setEmail(docSnap.data().email)

      reset({
        firstName: docSnap.data().firstName,
        surname: docSnap.data().surname,
        // email: docSnap.data().email
      });

    } else {
      console.log("No such document!");
    }
  }

  function cancelEdit() {}

  async function onSubmit(data) {
    const name = `${data.firstName} ${data.surname}`;
    await setDoc(doc(db, "users", userID), {
      ...data,
      name,
      id: userID,
      avatar: null,
      mobilePhoneNumber: "-",
      profileStatus: "incomplete"
    });
    console.log("User added");
  }

  const getDefaultCountryFromLocale = () => {
    const locale = navigator.language || "en-GB";
    const countryCode = locale.split("-")[1] || "GB";
    return countryCode.toUpperCase();
  };

  return (
    <>
      <BreadCrumbs
        breadcrumbs={[
          { name: "Launchpad", href: "/main/launchpad" },
          { name: "Account Profile", href: "/main/launchpad/UserProfile", current: true },
        ]}
      />
      <main className="w-full flex flex-col items-center">
        <Box sx={{ width: "100%", m: 0, p: 2, pt: 2, pl: 5 }} className="mx-auto">
          <h1>Your Profile</h1>
        </Box>
        <div className={`flex bg-white rounded-xl shadow-lg overflow-hidden flex-row ${classes.wrapper}`}>
          <div className="flex w-full">
            <Box className="p-6 w-full bg-slate-100 text-sm">
              <>
                <div className="flex items-center justify-between w-full pr-8">
                  <h3 className="ml-2 my-8 font-bold">Please update your profile:</h3>
                </div>
                <form onSubmit={handleSubmit(onSubmit)} className="bg-white shadow-sm ring-1 ring-gray-900/5 rounded-xl">
                  <div className="flex overflow-hidden justify-center">
                    <div className="p-6 flex flex-col w-full md:w-3/4 lg:w-1/3">
                      <div className="flex w-full justify-end text-pink-500 pr-4">* Required Items</div>

                        <div className="bg-slate-100 border-[1px] border-slate-200 rounded-xl p-8 mt-6"><span className="block font-semibold pb-4">Account ID:</span>{email}</div>                      

                        <div className="mt-4 mb-2">
                          <RTKTextField
                            name="firstName"
                            label="First Name *"
                            control={control}
                            rules={{
                              required: "First name  is required",
                              pattern: {
                                value: /^[A-Za-zÀ-ÿ' -]+$/u,
                                message: "Only letters, spaces, apostrophes, and hyphens are allowed",
                              },
                            }}
                            fullWidth
                          />
                        </div>

                        <div className="mt-2 mb-2">
                          <RTKTextField
                            name="surname"
                            label="Surname *"
                            control={control}
                            rules={{
                              required: "Surname is required",
                              pattern: {
                                value: /^[A-Za-zÀ-ÿ' -]+$/u,
                                message: "Only letters, spaces, apostrophes, and hyphens are allowed",
                              },
                            }}
                            fullWidth
                          />
                        </div>

                        <div className="mt-2 mb-2">
                          <div className="pb-2">Mobile Phone Number *</div>
                          <Controller
                            name="phone"
                    
                            control={control}
                            rules={{
                              validate: (value) =>
                                value && matchIsValidTel(value) || "Invalid phone number",
                            }}
                            render={({ field: { value, onChange, ref }, fieldState: { error } }) => (
                              <MuiTelInput
                                value={value || ""}
                                onChange={onChange}
                                inputRef={ref}
                                defaultCountry={getDefaultCountryFromLocale()}
                                error={!!error}
                                helperText={error?.message}
                              />
                            )}
                          />
                          <div className="py-2 text-xs">This will be used to message you</div>
                        </div>

                      <div className="mt-2 mb-2">
                        <RTKAvatarEditor currentUserID={userID} name={name}/>
                      </div>
                    </div>
                  </div>

                  <div className="flex items-center justify-end gap-x-6 border-t border-gray-900/10 px-4 py-4 sm:px-8">
                    <Button variant="outlined" onClick={cancelEdit}>
                      Cancel
                    </Button>
                    <Button variant="contained" size="medium" type="submit">
                      Save User
                    </Button>
                  </div>
                </form>
              </>
            </Box>
          </div>
        </div>
      </main>
    </>
  );
};

export default UserProfile;
